import {
  Box,
  Button,
  HStack,
  Icon,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
  VStack,
  Wrap,
} from "@chakra-ui/react";
import { CaretDoubleRight, MagnifyingGlass } from "@phosphor-icons/react";
import { Link, useNavigate } from "react-router-dom";
import Container from "../components/Container";
import Footer from "../components/Footer";
import LandingCourseList from "../components/list/LandingCourseList";
import PopularTema from "../components/list/PopularTema";
import Nav from "../components/nav/Nav";
import tags from "../const/tags";
import useSearchAllCourses from "../globalState/useSearchAllCourses";
import useScreenHeight from "../lib/useGetScreenHeight";

export default function Landing() {
  const sh = useScreenHeight();
  const { search, setSearch } = useSearchAllCourses();
  const navigate = useNavigate();

  return (
    <VStack gap={0}>
      <Nav />

      <VStack minH={sh < 700 ? "100vh" : "500px"} gap={0}>
        <Container flex={1} py={6} justify={"center"} minH={"800px"}>
          <VStack align={"center"} justify={"center"} w={"100%"} mb={12}>
            <Image src="/vectors/course.svg" w={"100%"} maxW={"520px"} mb={4} />

            <Text
              fontSize={52}
              fontWeight={700}
              lineHeight={1.2}
              mb={4}
              color={"p.500"}
              textAlign={"center"}
            >
              Online Course Gratis di Kubu.id
            </Text>

            <Text fontSize={18} mb={4} textAlign={"center"} maxW={"640px"}>
              Upgrade kemampuanmu untuk mendapatkan jenjang karir yang lebih
              baik. Dapatkan pelatihan online dari narasumber yang berpengalaman
              dan kompeten di bidangnya
            </Text>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                navigate("/allcourses");
              }}
              style={{ width: "100%" }}
            >
              <InputGroup mx={"auto"} w={"100%"} maxW={"300px"}>
                <InputLeftElement>
                  <Icon as={MagnifyingGlass} />
                </InputLeftElement>
                <Input
                  className="filled"
                  placeholder="Cari course"
                  _placeholder={{ opacity: 0.8 }}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                  value={search}
                />
              </InputGroup>
            </form>
          </VStack>
        </Container>
      </VStack>

      <Container py={6}>
        <Text fontSize={24} fontWeight={700} mb={6}>
          Temukan Online Course Favoritmu
        </Text>
        <HStack w={"100%"} mb={4} align={"flex-start"}>
          <Text py={2}>Populer</Text>

          <PopularTema />
        </HStack>

        <VStack align={"stretch"} mb={12}>
          <LandingCourseList />
        </VStack>

        <Button
          colorScheme="ap"
          variant={"outline"}
          fontSize={32}
          fontWeight={600}
          mb={2}
          w={"fit-content"}
          mx={"auto"}
          px={"50px !important"}
          transition={"200ms"}
          h={"50px"}
          rightIcon={
            <Icon
              as={CaretDoubleRight}
              fontSize={20}
              color={"p.500"}
              _groupHover={{ color: "white" }}
              transition={"200ms"}
            />
          }
          as={Link}
          to={"/allcourses"}
        >
          Temukan semua course
        </Button>
      </Container>

      <Container py={20}>
        <Wrap justify={"center"} spacing={4}>
          {tags.map((tag, i) => (
            <HStack
              key={i}
              p={4}
              borderRadius={8}
              // border={"1px solid var(--p500)"}
              bg={"var(--p500a)"}
              flex={"0 0 350px"}
              justify={"center"}
            >
              <Icon as={tag.icon} fontSize={48} color={"p.500"} />
              <Box>
                <Text fontWeight={600} color={"p.500"}>
                  {tag.title}
                </Text>
                <Text color={"p.500"}>{tag.narasi}</Text>
              </Box>
            </HStack>
          ))}
        </Wrap>
      </Container>

      <Footer />
    </VStack>
  );
}
